import { Destination } from "../aglsl/Destination";
var Token = (function () {
    function Token() {
        this.dest = new Destination();
        this.opcode = 0;
        this.a = new Destination();
        this.b = new Destination();
    }
    return Token;
}());
export { Token };



// WEBPACK FOOTER //
// ../dist/lib/aglsl/Token.js